export default __webpack_public_path__ + "static/media/flametongue.53cf1d90.png";